import { ETAPA } from "./etapas";

export const PLAYBOOKS = {
  [ETAPA.COMPRAS]: {
    identificar: {
      titulo: "Identificar",
      acao:
        "Compras está represando o fluxo. Verificar quais ambientes estão com aprovação preenchida e MDF_BORDO ainda 'X' há mais tempo.",
      ondeNoApp: "Tabela 'Top 10 ambientes críticos' filtrada por etapa Compras.",
    },
    explorar: {
      titulo: "Explorar",
      acao:
        "Revisar parâmetros de mín/máx de estoque. Antecipar pedidos de itens recorrentes (MDF, ferragens padrão) para encurtar lead time. Cobrar fornecedores com prazo estourado.",
      ondeNoApp: "Drawer de parâmetros → 'Compras'.",
    },
    subordinar: {
      titulo: "Subordinar",
      acao:
        "Reduzir o tamanho do lote liberado para Máquinas até Compras estabilizar. Não acionar Marcenaria sem MDF_BORDO confirmado.",
    },
    elevar: {
      titulo: "Elevar",
      acao:
        "Negociar contratos de fornecimento contínuo (kanban com fornecedor) para SKUs frequentes. Avaliar 2º fornecedor para itens críticos.",
    },
    repetir: {
      titulo: "Repetir o ciclo",
      acao:
        "Quando Compras não for mais o gargalo, reavaliar. O próximo gargalo provável é Máquinas — monitorar utilização lá.",
    },
  },

  [ETAPA.MAQUINAS]: {
    identificar: {
      titulo: "Identificar",
      acao:
        "Máquinas está com utilização > 100%. Listar ambientes com MDF_BORDO preenchido e FINAL_MAQUINAS vazio.",
    },
    explorar: {
      titulo: "Explorar",
      acao:
        "Avaliar 2º turno parcial; agrupar setups por cor/cliente; garantir que MDF está OK (campo MDF_BORDO) para os próximos 10 da fila antes do operador começar.",
    },
    subordinar: {
      titulo: "Subordinar",
      acao:
        "Compras reduz lote. Marcenaria não recebe ambiente sem FINAL_MAQUINAS preenchido. Acabamento entra em modo puxado.",
    },
    elevar: {
      titulo: "Elevar",
      acao:
        "Terceirizar corte/usinagem nas próximas semanas; cotar 2º centro de usinagem; horas-extras programadas no CCR.",
    },
    repetir: {
      titulo: "Repetir o ciclo",
      acao:
        "Quando Máquinas estabilizar, Marcenaria provavelmente vira gargalo. Reavaliar capacidades.",
    },
  },

  [ETAPA.TERCEIROS]: {
    identificar: {
      titulo: "Identificar",
      acao:
        "Terceiros está represando. Listar ambientes com itens (BI–BN > 0) e RECEBIMENTO_TERCEIROS vazio, especialmente os com ENTREGA_TERCEIROS já vencida.",
    },
    explorar: {
      titulo: "Explorar",
      acao:
        "Cobrança diária por tipo de terceiro (Serralheria, Vidraçaria, etc.). Pulmão de montagem para absorver atrasos. Prioridade para o ambiente com pulmão preto.",
    },
    subordinar: {
      titulo: "Subordinar",
      acao:
        "Marcenaria adapta sequência: trabalha primeiro nos ambientes que NÃO precisam de terceiros (todas as colunas BI–BN = X) enquanto Terceiros não chega.",
    },
    elevar: {
      titulo: "Elevar",
      acao:
        "Homologar 2º fornecedor por categoria. Avaliar internalização do processo crítico (ex: serralheria leve in-house).",
    },
    repetir: {
      titulo: "Repetir o ciclo",
      acao:
        "Reavaliar mensalmente quais categorias de terceiros mais estouram ENTREGA_TERCEIROS — atacar as recorrentes primeiro.",
    },
  },

  [ETAPA.MARCENARIA]: {
    identificar: {
      titulo: "Identificar",
      acao:
        "Marcenaria está com utilização > 100%. Listar ambientes com MARCENARIA_INICIO preenchido e MARCENARIA_TERMINO vazio.",
    },
    explorar: {
      titulo: "Explorar",
      acao:
        "Balancear carga entre marceneiros (campo MARCENEIRO_RESPONSAVEL) — hoje a carga concentra em poucos nomes. Evitar multitarefa: 1 marceneiro/ambiente até terminar. Pré-separar ferragens (FERRAGENS_ESPECIAIS_QTD) antes de iniciar para não parar no meio.",
    },
    subordinar: {
      titulo: "Subordinar",
      acao:
        "Acabamento entra em modo puxado pela saída da Marcenaria. Compras ajusta lote. Liberação para Marcenaria só com FINAL_MAQUINAS e RECEBIMENTO_TERCEIROS confirmados.",
    },
    elevar: {
      titulo: "Elevar",
      acao:
        "Acionar empreita externa (modelos LUQUINHAS / TEBAL EMPREITA EXTERNA já existentes na base). Avaliar mais um marceneiro CLT. Pintura/lixamento manual por ajudante para liberar o marceneiro principal.",
    },
    repetir: {
      titulo: "Repetir o ciclo",
      acao:
        "Quando Marcenaria estabilizar, Acabamento provavelmente vira o próximo gargalo. Reavaliar capacidades.",
    },
  },

  [ETAPA.ACABAMENTO]: {
    identificar: {
      titulo: "Identificar",
      acao:
        "Acabamento está com fila. Listar ambientes com itens em CA–CD pendentes (número, não data) e ACABAMENTO_REALIZADO vazio.",
    },
    explorar: {
      titulo: "Explorar",
      acao:
        "Dividir tarefas: lixar e pintar em paralelo. Cabines extras quando possível. Priorizar os ambientes com pulmão vermelho/preto.",
    },
    subordinar: {
      titulo: "Subordinar",
      acao:
        "Expedição puxa pela saída de Acabamento. Marcenaria desacelera entrega de novos ambientes se a fila de Acabamento crescer demais.",
    },
    elevar: {
      titulo: "Elevar",
      acao:
        "2º turno na cabine de pintura. Investir em equipamento (pistola HVLP, estufa). Terceirizar pintura de portas/perfis em pico.",
    },
    repetir: {
      titulo: "Repetir o ciclo",
      acao:
        "Quando Acabamento estabilizar, Expedição vira o próximo elo. Monitorar limpeza/embalagem/carregamento.",
    },
  },

  [ETAPA.EXPEDICAO]: {
    identificar: {
      titulo: "Identificar",
      acao:
        "Expedição está represando. Listar ambientes com LIMPEZA_EMBALAGEM preenchido e CARREGAMENTO vazio.",
    },
    explorar: {
      titulo: "Explorar",
      acao:
        "Agrupar entregas por região para reduzir viagens. Antecipar limpeza/embalagem dos próximos do tambor para o caminhão sair cheio.",
    },
    subordinar: {
      titulo: "Subordinar",
      acao:
        "Acabamento sincroniza saída com janelas de carregamento. Não acumular ambiente pronto sem rota definida.",
    },
    elevar: {
      titulo: "Elevar",
      acao:
        "Mais um caminhão / rota terceirizada em pico. Janela de carregamento extra (sábado).",
    },
    repetir: {
      titulo: "Repetir o ciclo",
      acao:
        "Quando Expedição estabilizar, voltar a olhar o ciclo do início — Compras costuma reaparecer.",
    },
  },
};
